import { gql } from 'apollo-boost';

const endClassGQL = gql`
  mutation endClass {
    endClass
  }
`;

export default endClassGQL;
